import React, {useState} from 'react';

import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';


function FundingNewsMentions(props) {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [anchorEl, setAnchorEl] =useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setPopoverOpen(true);
    };

    const getRootDomain = (url) => {
        try {
            const urlObject = new URL(url);
            let hostname = urlObject.hostname;

            // Remove "www." if present
            hostname = hostname.replace(/^www\./, '');
            return hostname;
        } catch (error) {
            // Handle invalid URL or other errors
            return null;
        }
    };

    if (!props.mentions.length) {
        return <div/>
    }

    return (
        <div>
            <div
                style={{display: "flex", flexDirection: "row", justifyContent: "right", cursor: "pointer", color:"rgb(0, 102, 153)"}}
                onClick={handleClick}
            >
                <Typography
                    sx={{marginRight: "6px"}}
                    variant={'subtitle2'}
                >
                    {props.mentions.length}
                </Typography>
                <svg role="img" width="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M5.6 12.4h11.726v-1.8H5.6v1.8Zm0-3h11.726V7.6H5.6v1.8Zm-1.8 9.7046c-.495 0-.9187-.1763-1.2712-.529C2.1763 18.223 2 17.799 2 17.3036V5.793c0-.4953.1763-.918.5288-1.268C2.8813 4.175 3.305 4 3.8 4h15.6c.495 0 .9188.1763 1.2713.529.3525.3527.5287.7767.5287 1.272v11.5106c0 .4954-.1762.918-.5287 1.268-.3525.35-.7763.525-1.2713.525H3.8Zm0-1.8h15.6V5.8H3.8v11.5046Z"></path><path fill="currentColor" d="M13.3656 15.3713H5.6v-1.8h7.7656v1.8Z"></path></svg>
            </div>

            <Popover
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={()=>{setPopoverOpen(false)}}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div style={{"margin": "12px"}}>
                    {props.mentions.map((mention) => (
                            <div
                                style={{display: "flex", flexDirection: "row", justifyContent: "left"}}
                                onClick={ () => {window.open(mention.url, "_blank");} }
                            >
                                <Typography
                                    sx={{marginRight: "6px", marginTop: "4px", color:"rgb(0, 102, 153)", cursor: "pointer"}}
                                    variant={'subtitle2'}
                                >
                                    {getRootDomain(mention.url)}
                                </Typography>
                                <svg role="img" width="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="rgb(0, 102, 153)" d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
                            </div>
                    ))}
                </div>
            </Popover>
        </div>
    )

}

export default FundingNewsMentions;